import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your Firebase configuration
// Replace these values with your actual Firebase project credentials
const firebaseConfig = {
  apiKey: "AIzaSyB5zSNfeWTpQN7AYOHTD75r86FBDFrhFVU",
  authDomain: "pms-web-38dc4.firebaseapp.com",
  projectId: "pms-web-38dc4",
  storageBucket: "pms-web-38dc4.firebasestorage.app",
  messagingSenderId: "604023874132",
  appId: "1:604023874132:web:4329d74455b3b74af003c1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app; 